import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faHome, faList, faUser, faThList} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from "react-router-dom";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><FontAwesomeIcon icon={faHome}/></div>
                    <span className="super-small-2">خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/requests">
                    <div><FontAwesomeIcon icon={faList}/></div>
                    <span className="super-small-2 ">درخواستها</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/requests-sc">
                    <div><FontAwesomeIcon icon={faThList}/></div>
                    <span className="super-small-2">درخواست خرد</span>
                </NavLink>
{/*                <NavLink className="nav-item nav-link  " to="/work-shifts">
                    <div><FontAwesomeIcon icon={faCheck}/></div>
                    <span className="super-small-2">شیفت کاری</span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><FontAwesomeIcon icon={faUser}/></div>
                    <span className="super-small-2">پروفایل</span>
                </NavLink>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;
